import React from 'react'
import Carousel from '../../components/carousel/carousel'

const Slider = (props) => {
  return (
    <div className="article__slider">
      <Carousel images={[
        '/images/slider/s8.jpg',
        '/images/slider/s9.jpg',
        '/images/slider/s10.jpg',
        '/images/slider/s11.jpg',
        '/images/slider/s12.jpg',
        '/images/slider/s13.jpg',
        '/images/slider/s14.jpg',
        '/images/slider/s15.jpg',
        '/images/slider/s16.jpg',
        '/images/slider/s17.jpg',
        '/images/slider/s18.jpg',
        '/images/slider/s19.jpg',
        '/images/slider/s20.jpg',
        '/images/slider/s21.jpg',
        '/images/slider/s22.jpg',
        '/images/slider/s23.jpg',
        '/images/slider/s24.jpg',
        '/images/slider/s25.jpg',
        '/images/slider/s26.jpg',
        '/images/slider/s27.jpg',
        '/images/slider/s28.jpg',
        '/images/slider/s29.jpg',
        '/images/slider/s30.jpg',
        '/images/slider/s31.jpg',
        '/images/slider/s32.jpg',
        '/images/slider/s33.jpg',
        '/images/slider/s7.jpg',
        '/images/slider/s34.jpg',
        '/images/slider/s35.jpg',
        '/images/slider/s36.jpg',
        '/images/slider/s37.jpg',
        '/images/slider/s38.jpg',
        '/images/slider/s39.jpg',
        '/images/slider/s40.jpg',
        '/images/slider/s41.jpg',
        '/images/slider/s42.jpg',
        '/images/slider/s43.jpg',
        '/images/slider/s44.jpg',
        '/images/slider/s45.jpg',
        '/images/slider/s46.jpg',
        '/images/slider/s47.jpg',
        '/images/slider/s48.jpg',
        '/images/slider/s49.jpg',
        '/images/slider/s50.jpg',
        '/images/slider/s51.jpg',
        '/images/slider/s52.jpg',
        '/images/slider/s53.jpg',
        '/images/slider/s54.jpg',
        '/images/slider/s55.jpg',
        '/images/slider/s56.jpg',
        '/images/slider/s57.jpg',
        '/images/slider/s58.jpg',
        '/images/slider/s59.jpg',
        '/images/slider/s60.jpg',
        '/images/slider/s61.jpg',
        '/images/slider/s62.jpg',
        '/images/slider/s63.jpg',
        '/images/slider/s64.jpg',
        '/images/slider/s65.jpg',
      ]}/>
    </div>
  )
}

export default Slider


// WEBPACK FOOTER //
// ./src/pages/home/slider.js